import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-spinner-table',
  templateUrl: './spinner-table.component.html',
  styleUrls: ['./spinner-table.component.scss']
})
export class SpinnerTableComponent {

  @Input() public visible:boolean;
  @Input() public isVisibleText:boolean;
  @Input() public message:string;



  constructor() {
    this.visible = false;
    this.message = "Caricamento in corso ...";
    this.isVisibleText = true;
  }

}
